import React from 'react'

function Parents() {
  return (
    <div className="dashboard">
        <h1>Parents</h1>
    </div>
  )
}

export default Parents